/* unplugin-vue-components disabled */import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "height": "68vh"
  }
};
import * as echarts from 'echarts';
import { getAlarmStatisticsByTaskId, getFlightDataByTaskId, getFlightDataMuByTaskId, getSatcomMuByTaskId } from "@/api/base/statistic";
export default {
  __name: 'statistic',
  setup(__props, {
    expose: __expose
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const visible = ref(false);
    const taskId = ref(undefined);

    // 显示弹框
    function show(taskid) {
      visible.value = true;
      taskId.value = taskid;
      nextTick(() => {
        initeCharts();
      });
    }
    let taskChart, taskChart1, taskChart2, taskChart3;
    const initeCharts = () => {
      taskChart = echarts.init(document.getElementById('taskChart'));
      taskChart.setOption(state.option);
      taskChart1 = echarts.init(document.getElementById('taskChart1'));
      taskChart1.setOption(state.option1);
      taskChart2 = echarts.init(document.getElementById('taskChart2'));
      taskChart2.setOption(state.option2);
      taskChart3 = echarts.init(document.getElementById('taskChart3'));
      taskChart3.setOption(state.option3);
      getList();
      getSpeedAndHeight();
    };
    function getList() {
      //TODO 载体任务飞行次数统计
      getAlarmStatisticsByTaskId({
        taskId: taskId.value
      }).then(response => {
        console.log(response.data);
        state.option.xAxis.data = response.data.xData;
        if (response.data.StatisticsList.length > 0) {
          state.option.series[0].data = [];
          response.data.StatisticsList.map(item => {
            state.option.series[0].data.push(item.nums);
          });
          taskChart.clear();
          taskChart.resize();
          taskChart.setOption(state.option, true);
        } else {
          state.option.series[0].data = [];
          taskChart.clear();
          taskChart.resize();
          taskChart.setOption(state.option, true);
        }
      });
    }
    const getSpeedAndHeight = () => {
      getFlightDataByTaskId({
        taskId: taskId.value
      }).then(response => {
        taskChart2.clear();
        console.log(response.data);
        let speedArray = response.data.StatisticsListSpeed;
        console.log(speedArray);
        state.option2.yAxis.data = response.data.xDataSpeed;
        if (response.data.StatisticsListSpeed.length > 0) {
          state.option2.series.data = speedArray;
          console.log("速度");
          console.log(state.option2);
          taskChart2.resize();
          taskChart2.setOption(state.option2, true);
        } else {
          state.option2.series.data = [];
          taskChart2.resize();
          taskChart2.setOption(state.option2, true);
        }
      });
      getFlightDataMuByTaskId({
        taskId: taskId.value
      }).then(response => {
        taskChart1.clear();
        console.log(response.data);
        let speedArray = response.data.StatisticsListSpeed;
        let heightArray = response.data.StatisticsListHeight;
        console.log(speedArray);
        state.option1.xAxis.data = response.data.xData;
        if (heightArray.length > 0) {
          // state.option1.series[1].data = speedArray;
          state.option1.series[0].data = heightArray;
          taskChart1.resize();
          taskChart1.setOption(state.option1, true);
        } else {
          state.option1.series.data = [];
          taskChart1.resize();
          taskChart1.setOption(state.option1, true);
        }
      });
      getSatcomMuByTaskId({
        taskId: taskId.value
      }).then(response => {
        taskChart3.clear();
        console.log(response.data);
        if (response.data.xData === undefined) return;
        state.option3.xAxis.data = response.data.xData;
        if (response.data.statisticsListUp.length > 0) {
          state.option3.graphic[0].style.text = response.data.total[0] + "\n" + response.data.total[1];
          state.option3.series[0].data = response.data.statisticsListUp;
          state.option3.series[1].data = response.data.statisticsListDown;
          console.log("高度");
          console.log(state.option3);
          taskChart3.resize();
          taskChart3.setOption(state.option3, true);
        } else {
          state.option3.series[0].data = [];
          taskChart3.resize();
          taskChart3.setOption(state.option3, true);
        }
      });
    };
    const state = reactive({
      option: {
        tooltip: {},
        xAxis: {
          name: "类别",
          data: []
        },
        yAxis: {
          name: "告警次数",
          type: "value"
        },
        series: [{
          name: "告警次数",
          type: "bar",
          data: [],
          barWidth: 30,
          label: {
            normal: {
              show: true,
              position: "top",
              textStyle: {
                color: "#ffffff",
                fontSize: "120%"
              }
            }
          }
        }]
      },
      option1: {
        color: ["#ee8a07"],
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          name: "时间",
          type: 'category',
          data: [15, 30, 45, 60, 75, 90, 105, 120]
        },
        yAxis: {
          name: "高度(m)",
          type: 'value'
        },
        series: [{
          name: "高度(m)",
          data: [15, 18, 22, 33, 48, 54, 61, 69],
          type: 'line'
        }]
      },
      option2: {
        tooltip: {},
        xAxis: {
          name: "秒",
          type: "value",
          axisTick: {
            show: true
          },
          axisLabel: {
            textStyle: {
              color: "#ffffff"
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff"
            }
          }
        },
        yAxis: {
          name: "飞行速度(m/s)",
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#ffffff"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          data: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60]
        },
        series: {
          type: "bar",
          name: "运行速度",
          itemStyle: {
            normal: {
              show: true,
              color: {
                type: "linear",
                colorStops: [{
                  offset: 1,
                  color: "#6fccff"
                }]
              },
              barBorderRadius: 88,
              borderWidth: 2,
              borderColor: "#333"
            }
          },
          label: {
            normal: {
              show: true,
              position: "right",
              textStyle: {
                color: "#ffffff",
                fontSize: "120%"
              }
            }
          },
          barGap: "0%",
          barCategoryGap: "20%",
          barMaxWidth: "30px",
          data: [22, 23, 33, 34, 36, 38, 39, 41, 42, 43, 32, 44]
        }
      },
      option3: {
        legend: {
          data: [{
            name: "上行流量(kb/s)",
            textStyle: {
              color: '#ffffff'
            }
          }, {
            name: "下行流量(kb/s)",
            textStyle: {
              color: '#ffffff'
            }
          }],
          top: 10
        },
        graphic: [{
          type: 'text',
          z: 100,
          right: 10,
          top: 30,
          style: {
            fill: '#f3eded',
            width: 180,
            overflow: 'break',
            text: '上行总流量：100000Kb \n下行总流量：5000kb',
            font: '14px Microsoft YaHei'
          }
        }],
        tooltip: {
          trigger: 'axis'
        },
        yAxis: {
          name: "瞬时流量(kb/s)",
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#ffffff"
            }
          }
        },
        xAxis: {
          name: "时间",
          type: "category",
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          data: [25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300]
        },
        series: [{
          name: "上行流量(kb/s)",
          type: "line",
          data: [5, 10, 18, 20, 15, 30, 25, 35, 19, 36, 14, 18],
          areaStyle: {}
        }, {
          name: "下行流量(kb/s)",
          type: "line",
          data: [5, 10, 18, 20, 15, 30, 25, 35, 19, 36, 14, 18],
          areaStyle: {}
        }]
      }
    });

    /** 关闭按钮 */
    function close() {
      visible.value = false;
    }
    ;
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "统计信息",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: close,
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12,
            xs: 24
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
              class: "menu-name",
              style: {
                "left": "1.6rem"
              }
            }, [_createElementVNode("span", {
              class: "textinfo"
            }, "告警类别统计")], -1), _createElementVNode("div", {
              class: "echarts0"
            }, [_createElementVNode("div", {
              id: "taskChart",
              style: {
                "width": "100%",
                "height": "100%"
              }
            })], -1), _createElementVNode("div", {
              class: "menu-name",
              style: {
                "left": "1.6rem"
              }
            }, [_createElementVNode("span", {
              class: "textinfo"
            }, "飞行高度统计")], -1), _createElementVNode("div", {
              class: "echarts1"
            }, [_createElementVNode("div", {
              id: "taskChart1",
              style: {
                "width": "100%",
                "height": "100%"
              }
            })], -1)]))]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12,
            xs: 24
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
              class: "menu-name",
              style: {
                "left": "1.6rem"
              }
            }, [_createElementVNode("span", {
              class: "textinfo"
            }, "飞行速度统计")], -1), _createElementVNode("div", {
              class: "echarts2"
            }, [_createElementVNode("div", {
              id: "taskChart2",
              style: {
                "width": "100%",
                "height": "100%"
              }
            })], -1), _createElementVNode("div", {
              class: "menu-name",
              style: {
                "left": "1.6rem"
              }
            }, [_createElementVNode("span", {
              class: "textinfo"
            }, "天线流量统计")], -1), _createElementVNode("div", {
              class: "echarts3"
            }, [_createElementVNode("div", {
              id: "taskChart3",
              style: {
                "width": "100%",
                "height": "100%"
              }
            })], -1)]))]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};